var rooms = vueIfExists({
	el: '#rooms',
	mixins: [win.toggleCollapse, win.buttonSpinner, win.displayPrice],
	data: {
		heading: '',
		rooms: [],
		rateConfig: {},
		thumbs: [],
		visible: false,
		loading: false,
		cache: {
			handle: null,
			query: {},
			pendingQuery: {},
			expiresSec: 5 * 60,
			time: 0,
			contents: {},
			pending: false
		},
		prefetch: false,
		sharedState: store.state,
		rateColumnTitle: '',
		attachCallback: false,
		loadedEvent: new Event('roomsLoaded', { bubbles: true }),
		percentageBooked: 0,
		minSubmitTime: 300,
		percentageBookedMessage: ''
	},
	created: function() {
		this.initRooms();
		this.currencyDecimals = 0;
	},
	methods: {
		initRooms: function() {
			if (Object.keys(this.sharedState.query).length !== 0 && this.sharedState.query.start && this.sharedState.query.end) {
				var result = win.calendar.validateDates(this.sharedState.query.start, this.sharedState.query.end );
				if (result.valid) {
					this.visible = true;
					this.getRooms({
						query: this.sharedState.query
					});
				} else {
					this.sharedState.errorType = result.errorType;
				}
			}
		},
		getRooms: function(config) {
			config = config || {};
			this.prefetch = config.prefetch;
			var cacheIsExpired = (new Date().getTime() / 1000 - this.cache.time) > this.cache.expiresSec,
				hasCachedJson = JSON.stringify(config.query) == JSON.stringify(this.cache.query),
				hasPendingQuery = JSON.stringify(config.query) == JSON.stringify(this.cache.pendingQuery),
				requiresRequest = (!hasCachedJson || cacheIsExpired) && !hasPendingQuery;

			if (!this.prefetch) {
				this.loading = true;
			}

			if (requiresRequest) {
				this.cache.pendingQuery = JSON.parse(JSON.stringify(config.query));
				this.cache.handle = win.$ajax.getJson({
					url: win.jsonUrl.hotelRooms,
					params: { q: $url.encodeQ(config.query), intHotelId: this.sharedState.hotel.id, sf: 1},
					abort: this.cache.handle,
					scope: this,
					success: function(json) {
						this.cache.query = JSON.parse(JSON.stringify(config.query));
						this.cache.contents = json;
						this.cache.time = new Date().getTime() / 1000;
						win.store.set('currencyDisplay', json.currencyDisplay);
						win.store.set('nightlyRates', json.rateConfig.nightlyRates);
						this.percentageBooked = json.percentageBooked || 0;

						if (!this.prefetch) {
							this.updateDisplay(json);
						}

					},
					failed: function(errorType) {
						// TODO define error states
						this.loading = false;
						if (!this.prefetch) {
							this.visible = false;
							win.store.set('errorType', errorType ? errorType : null);
						}
					},
                    always: function() {
						this.cache.pendingQuery = {};
						if (!config.callback && this.attachCallback) {
							config.callback = this.attachCallback;
							this.attachCallback = false;
						}
                        if (config.callback) config.callback.call(config.scope);
                    }
				});
			} else {
				if (hasPendingQuery) {
					if (!this.prefetch) {
						this.loading = true;
						if (this.sharedState.errorType != 'soldOut') {
							this.visible = true;
						}
					}
					this.attachCallback = config.callback;
				} else {
					window.setTimeout(function(caller) { return function() {
						if (!caller.prefetch) {
							caller.updateDisplay(caller.cache.contents);
						}
						if (config.callback) config.callback.call(config.scope);
			        };}(this), this.minSubmitTime);
				}
			} 
		},
		updateDisplay: function(json) {
			win.store.set('errorType', json.errorType ? json.errorType : null);
			if (!json.errorType) {
				this.showRooms();
			} else {
				this.visible = false;
			}
			if (win.alternativeHotels) {
				win.alternativeHotels.setData(json.alternativeHotels);
			}

			if (json.errorType == 'soldOut') {
				if (json.alternativeHotels && json.alternativeHotels.hotels.length > 0) {
					win.virtualPageView('Hotel_Detail WithDates NotAvailable');
				} else {
					win.virtualPageView('Hotel_Detail WithDates NotAvailable (no list)');
				}
			} else {
				win.virtualPageView('Hotel_Detail WithDates');
			}

			document.dispatchEvent(this.loadedEvent);
		},
		showRooms: function() {
			this.rooms = this.cache.contents.rooms || [];
			this.rateConfig = this.cache.contents.rateConfig;
		    this.currencyDisplay = this.cache.contents.currencyDisplay;
			this.heading = this.getHeading();
			this.rateColumnTitle = this.getRateColumnTitle();
			this.percentageBookedMessage = i18n.percentageBooked.replace('%0%', this.percentageBooked);
			this.visible = true;
			this.loading = false;
			this.showMaximumDiscount();
			if (win.availCheckForm) win.availCheckForm.disabledButton = true;			
		},
		getHeading: function() {
			var rooms = win.$url.decodeRmcnf(this.cache.query.rmcnf),
				adults = 0,
				children = 0,
				startDate = win.calendar.parseDate(this.cache.query.start),
				endDate = win.calendar.parseDate(this.cache.query.end),
				endYear = endDate.getFullYear(),
				nights = win.calendar.diffDays(endDate, startDate),
				startDateFormatted = win.calendar.fullDateString(startDate),
				endDateFormatted = win.calendar.fullDateString(endDate),
				bold = function(str) {
					return '<strong>'+str+'</strong>';
				};
			for (var room = 0; room < rooms.length; room++) {
				adults += rooms[room].adults;
				children += rooms[room].children; 
			}
			var str = win.i18n.availableRoomsFrom
				.replace('%0%', bold(startDateFormatted))
				.replace('%1%', bold(endDateFormatted+' '+endYear));
			str += ', ' + win.i18n.for + ' ' + bold(nights + ' ' + win.i18n.night[nights == 1 ? 0 : 1]);
			str += ', ' + bold(rooms.length + ' ' + win.i18n.room[rooms.length == 1 ? 0 : 1]);
			str += ', ' + bold(adults + ' ' + win.i18n.adult[adults == 1 ? 0 : 1]);
			if (children) {
				str += ', ' + bold(children + ' ' + win.i18n.child[children == 1 ? 0 : 1]);
			}
			if (win.isMobile) {
				var priceTxt = [];
				if (this.rateConfig.nightlyRates && (rooms.length > 1 || nights > 1)) {
					priceTxt.push(this.i18n.prices + ' ' + this.i18n.perRoomPerNight);
				}
				if (this.sharedState.currency == 'USD') {
					priceTxt.push('US$');
				}
				if (priceTxt.length) {
					str += ' (' + priceTxt.join(', ') + ')';
				}
			}
			return str;
		},
		getRateColumnTitle: function() {
			if (!this.cache.query.start || !win.calendar) return '';
			var startDate = win.calendar.parseDate(this.cache.query.start),
				endDate = win.calendar.parseDate(this.cache.query.end),
				nights = win.calendar.diffDays(endDate, startDate);
				title = this.rateConfig.nightlyRates ? this.i18n.perRoomPerNight : 
					this.i18n[nights == 1 ? 'rateForXNight' : 'rateForXNights'].replace('%0%', nights);
			if (this.sharedState.currency == 'USD') {
				title += ' (US$)';
			}
			return title;
		},
		getLowAvailabilityText: function(roomsAvailable) {
			var key ='xLeft';
			if (roomsAvailable == 1) {
				key = 'oneLeft';
			} else if (roomsAvailable <= 3) {
				key = 'onlyXLeft';
			}
			return this.i18n[key].replace('%0%', roomsAvailable);
		},
		getRoomsLeftTooltip: function(room, rate) {
			return this.i18n[room.availability == 1 ? 'roomLeftToolTip' : 'XroomsLeftToolTip']
				.replace('%0%', '<strong>')
				.replace('%1%', room.availability)
				.replace('%2%', this.price(rate.price, this.currency, 0, this.currencyDisplay))
				.replace('%3%', '</strong>')
				.replace('%4%', '');
		},
		getBookBtnTxt: function(room, rate, roomIndex, rateIndex) {			        
			var btnTxt = this.i18n.bookButton;
			if (["en", "es", "pt"].indexOf(this.sharedState.locale) == -1) return btnTxt;
			if (room.availability == 1) {
				btnTxt = this.i18n.lastRoomBtn;
			} else if (rate.type.payNow !== true) {
				btnTxt = this.i18n.payLaterBtn;
			} else if (rate.promotion) {
				var percentageMatch = rate.promotion.match(/\d+\s?%/);
				if (percentageMatch) {
				    btnTxt = this.i18n.saveBtn.replace('%0%', percentageMatch[0]);
				}
			} else if (roomIndex == 0 && rateIndex == 0) {
				btnTxt = this.i18n.lowestRateBtn;
			}
			return btnTxt;
		},
		clickBook: function(event) {
			this.startBtnLoader(event.target); 
		},
		showDetails: function($event, room) {
			$event.preventDefault();
			var detailsPanel = 'details-'+room.id;
			var imageUrls = [];
			// initialize carousel if it does not yet exist
			if (!win['roomCarousel'+room.id]) {
				room.images.forEach(function(image) {
					imageUrls.push('https://s1.hocdn.com/cache/exp/360x240'+image.url);
				});
				win['roomCarousel'+room.id] = new win.carousel(this.$refs[detailsPanel][0].querySelector('.room-photo-carousel'), imageUrls, true);
			}
			var isCollapsed = this.toggleCollapse(null, {target: detailsPanel});
			if (win.isMobile && !isCollapsed) {
				$d.scrollto({ distance: win.innerHeight / -2, toElement: this.$refs[detailsPanel][0] });
			}
		},
		showMaximumDiscount: function() {
			var discountMax = 0, 
				discount,
				rateObj,
				matches;
			for (var room = 0; room < this.rooms.length; room++) {
				for (var rate = 0; rate < this.rooms[room].rates.length; rate++) {
					rateObj = this.rooms[room].rates[rate];
					matches = rateObj.promotion && rateObj.promotion.match(/\d+\s?\%/);
					if (matches) {
						discount = parseInt(matches[0]);
					}
					else if (rateObj.strikethrough && rateObj.price) {
						discount = 100*(rateObj.strikethrough - rateObj.price)/rateObj.strikethrough;
					}
					if (discount > discountMax) discountMax = discount;
				}
			}
			if (win.hotelHeaderMenu) {
				win.hotelHeaderMenu.setDiscountLabel(discountMax);
			} 
		}
	}
});